import type React from 'react';

import { Checkbox } from '@vlabs/uikit/components/controls/checkbox';
import type { WithDataTestid } from '@vlabs/uikit/types';
import type { PathValue } from 'react-hook-form';

import { PointVisiblePages } from '../types';
import type { EditPermissionsFormProps } from '../types';
import { useEditPermissionsFormContext } from '../useEditPermissionsFormContext';
import st from './Cell.module.sass';

// временно работаем только с видимыми страницами POINT 3
// после обновления списка страниц можно вернуть Object.values(PointPermissionPages).
const visiblePages = new Set<string>(PointVisiblePages);

const forceCheck = (current: string[]): string[] => {
  const merged = new Set(current);
  PointVisiblePages.forEach((page) => merged.add(page));
  return [...merged];
};

// скрытые страницы не трогаем, чтобы при сохранении роли не стереть старые доступы.
const forceUncheck = (current: string[]): string[] => (
  current.filter((page) => !visiblePages.has(page))
);

interface AllPagesProps extends WithDataTestid {
  disabled?: boolean;
}

function AllPages({
  disabled = false,
  'data-testid': dataTestId = undefined,
}: AllPagesProps): React.JSX.Element {
  const { watch, setValue } = useEditPermissionsFormContext();
  const pagesList = (watch('pages') ?? []) as string[];
  const visibleCount = pagesList.filter((page) => visiblePages.has(page)).length;
  const checked = visibleCount === PointVisiblePages.length;
  const indeterminate = visibleCount !== 0 && !checked;

  return (
    <div className={st.Cell}>
      <Checkbox
        checked={checked || indeterminate}
        data-testid={dataTestId}
        disabled={disabled}
        indeterminate={indeterminate}
        onClick={() => {
          const updatePages = checked ? forceUncheck : forceCheck;

          setValue(
            'pages',
            updatePages(pagesList) as PathValue<EditPermissionsFormProps, 'pages'>,
          );
        }}
      />
    </div>
  );
}

export { AllPages };
